var _style, _path, _path2, _path3, _polygon, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _polygon2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 34",
    style: {
      enableBackground: "new 0 0 150 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4E596B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146,0H3.7C1.7,0,0,1.7,0,3.7c0,0,0,0,0,0v26.5C0,32.3,1.7,34,3.7,34H146c2.2,0,4-1.8,4-4V4 C150,1.8,148.2,0,146,0z M149,30c0,1.7-1.3,3-3,3H3.7C2.2,33,1,31.8,1,30.3V3.7C1,2.2,2.2,1,3.7,1H146c1.7,0,3,1.3,3,3V30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.1,11.2h-4.3V22h1.9v-4.2h2.4c2.4,0,3.9-1.2,3.9-3.3S19.5,11.2,17.1,11.2z M17,16.2h-2.3v-3.3H17 c1.4,0,2.1,0.6,2.1,1.6S18.4,16.2,17,16.2L17,16.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.1,14c-2.1,0-3.8,1.6-3.8,3.7c0,0.1,0,0.2,0,0.4c-0.2,2.1,1.4,3.9,3.5,4.1c2.1,0.2,3.9-1.4,4.1-3.5 c0-0.2,0-0.5,0-0.7c0.2-2.1-1.3-3.9-3.4-4.1C25.4,14,25.2,14,25.1,14z M25.1,20.7c-1.2,0-2-1-2-2.6s0.8-2.6,2-2.6s2,1,2,2.6 S26.3,20.7,25.1,20.7L25.1,20.7z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "36.8,19.4 35.4,14.1 33.9,14.1 32.5,19.4 31.1,14.1 29.2,14.1 31.6,22 33.2,22 34.6,16.9 36,22  37.6,22 40,14.1 38.2,14.1 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44,14c-2.1,0-3.8,1.8-3.8,3.9c0,0.1,0,0.1,0,0.2c-0.2,2.1,1.4,3.9,3.5,4.1c0.1,0,0.2,0,0.4,0 c1.5,0.1,2.9-0.8,3.4-2.2L46,19.4c-0.2,0.8-1,1.3-1.8,1.3c-1.2,0-2.1-0.9-2.2-2.1c0,0,0-0.1,0-0.1h5.5v-0.6C47.5,15.7,46.3,14,44,14 z M42.1,17.1c0.1-0.9,1-1.6,1.9-1.6c0.9-0.1,1.6,0.6,1.7,1.4c0,0.1,0,0.1,0,0.2L42.1,17.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.7,15.3v-1.2h-1.8V22h1.8v-4.1c-0.1-1,0.7-1.9,1.8-2c0.1,0,0.2,0,0.2,0c0.2,0,0.4,0,0.7,0v-1.8 c-0.1,0-0.3,0-0.5,0C51.9,14,51.1,14.5,50.7,15.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.5,14c-2.1,0-3.8,1.8-3.8,3.9c0,0.1,0,0.1,0,0.2c-0.2,2.1,1.4,3.9,3.5,4.1c0.1,0,0.2,0,0.4,0 c1.5,0.1,2.8-0.8,3.4-2.2l-1.5-0.6c-0.2,0.8-1,1.3-1.8,1.3c-1.2,0-2.1-1-2.1-2.1c0,0,0,0,0,0H61v-0.6C61,15.7,59.8,14,57.5,14z  M55.5,17.1c0.1-0.9,1-1.6,1.9-1.6c0.9-0.1,1.6,0.6,1.7,1.4c0,0.1,0,0.1,0,0.2H55.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.6,15c-0.6-0.7-1.4-1-2.3-1c-2.2,0-3.5,1.9-3.5,4.1s1.3,4.1,3.5,4.1c0.9,0,1.7-0.3,2.3-1V22h1.8V11.2h-1.8 V15z M67.6,18.4c0.2,1.1-0.6,2.1-1.7,2.3c-0.1,0-0.2,0-0.3,0c-1.3,0-2-1-2-2.5s0.7-2.5,2-2.5c1.1,0,2,0.8,2,2.3V18.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.3,14c-0.9,0-1.7,0.3-2.3,1v-3.8h-1.8V22H77v-0.8c0.6,0.7,1.4,1,2.3,1c2.2,0,3.5-1.9,3.5-4.1 S81.5,14,79.3,14z M79,20.6c-1.1,0-2-0.9-2-2c0-0.1,0-0.2,0-0.3v-0.5c0-1.5,0.8-2.3,2-2.3c1.3,0,2,1,2,2.5S80.2,20.6,79,20.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.9,19.7L85,14.1h-1.9l2.9,7.6l-0.3,0.7c-0.1,0.5-0.6,0.9-1.1,0.8c-0.2,0-0.4,0-0.6,0v1.5 c0.2,0,0.5,0.1,0.7,0c1.3,0.1,2.5-0.7,2.8-2l3.2-8.6h-1.9L86.9,19.7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125,12.4c-0.8,0-1.6,0.3-2.1,0.9l-0.1-0.7h-2.4v12.9l2.7-0.6v-3.1c0.5,0.5,1.2,0.7,1.9,0.7 c1.9,0,3.7-1.6,3.7-5.1C128.7,14.2,126.9,12.4,125,12.4z M124.3,20.1c-0.5,0-1-0.2-1.3-0.5v-4.1c0.3-0.4,0.8-0.6,1.3-0.6 c1,0,1.7,1.1,1.7,2.6S125.4,20.1,124.3,20.1z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.7,12.4c-2.6,0-4.2,2.3-4.2,5.1c0,3.4,1.9,5.1,4.6,5.1c1,0,2.1-0.2,3-0.7v-2.3c-0.8,0.4-1.8,0.6-2.7,0.6 c-1.1,0-2-0.4-2.1-1.7h5.4c0-0.1,0-0.7,0-1C137.7,14.7,136.4,12.4,133.7,12.4z M132.3,16.5c0-1.3,0.8-1.8,1.4-1.8s1.4,0.5,1.4,1.8 H132.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113,13.4l-0.2-0.8h-2.3v9.7h2.7v-6.6c0.5-0.6,1.3-0.8,2.1-0.6v-2.6C114.4,12.2,113.4,12.6,113,13.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.5,15.5c0-0.4,0.4-0.6,0.9-0.6c0.9,0,1.9,0.3,2.7,0.7v-2.6c-0.9-0.3-1.8-0.5-2.7-0.5c-2.2,0-3.7,1.2-3.7,3.2 c0,3.1,4.1,2.6,4.1,3.9c0,0.5-0.4,0.7-1,0.7c-1.1-0.1-2.1-0.4-3-0.9V22c0.9,0.4,2,0.6,3,0.6c2.3,0,3.8-1.1,3.8-3.2 C103.6,16.1,99.5,16.7,99.5,15.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.3,10.2l-2.7,0.6v8.9c-0.1,1.5,1.1,2.8,2.7,2.9c0.1,0,0.1,0,0.2,0c0.7,0,1.3-0.1,1.9-0.4V20 c-0.3,0.1-2.1,0.7-2.1-1v-4h2.1v-2.3h-2.1L107.3,10.2z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "116.2,11.7 119,11.1 119,9 116.2,9.5 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 116.2,
    y: 12.6,
    className: "st0",
    width: 2.7,
    height: 9.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.74b9b81a286cabaa3e948bea5370e825.svg";
export { ForwardRef as ReactComponent };